// @flow

import { createSelector } from 'reselect'

type Action = {
  +type: string,
  payload: Object,
}

//Constants
export const FETCH_PUBLISHERS_REVENUE_REQUEST =
  'opinary/FETCH_PUBLISHERS_REVENUE_REQUEST'
export const FETCH_PUBLISHERS_REVENUE_SUCCESS =
  'opinary/FETCH_PUBLISHERS_REVENUE_SUCCESS'

export const CHANGE_REVENUE_METRIC = 'opinary/CHANGE_REVENUE_METRIC'

const InitialRevenueState = {
  customer: '',
  createdLte: Date.now(),
  createdGte: Date.now(),
  spans: [],
  totals: {
    impressions: 0,
    cpm: 0,
    payout: 0,
  },
}

// Root Selector
export const getRoot = (state: Object) => state

export const getRevenue = createSelector(
  getRoot,
  ({ publisherRevenue }) => publisherRevenue.data || InitialRevenueState
)

export const getRevenueSpans = createSelector(
  getRevenue,
  ({ spans }) => spans || []
)

export const getLoadingState = createSelector(
  getRoot,
  ({ publisherRevenue }) => publisherRevenue.isloading || false
)

export const getCurrentMetric = createSelector(
  getRoot,
  ({ publisherRevenue }) => publisherRevenue.metric || 'impressions'
)

//Actions
export const fetchPublisherRevenue = (date: Date) => ({
  type: FETCH_PUBLISHERS_REVENUE_REQUEST,
  payload: date,
})

export const changeMetric = (metric: string) => ({
  type: CHANGE_REVENUE_METRIC,
  payload: metric,
})

const initalState = {
  isloading: false,
  metric: 'impressions',
}

const publishersRevenue = (state: Object = initalState, action: Action) => {
  switch (action.type) {
    case FETCH_PUBLISHERS_REVENUE_REQUEST:
      return {
        ...state,
        isloading: true,
      }

    case CHANGE_REVENUE_METRIC:
      return {
        ...state,
        metric: action.payload,
      }
    case FETCH_PUBLISHERS_REVENUE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isloading: false,
      }
    default:
      return state
  }
}

export default publishersRevenue



// WEBPACK FOOTER //
// ./src/stores/report/revenue.js